// 003 (FR-003, FR-004; P-JOIN-1; research R3): a school code as typed or linked. Malformed codes
// never reach the rate-limited lookup.
import { JOIN_CODE } from "./pendingJoin";

/** Upper case, spaces and hyphens removed ("gps 7k2" → "GPS7K2"). */
export function normaliseSchoolCode(raw: string): string {
  return raw.replace(/[\s-]+/g, "").toUpperCase();
}

export function isValidSchoolCode(code: string): boolean {
  return JOIN_CODE.test(code);
}
